import templateUrl from "emun.on-demand/media/extend-design-prompt.htm";
import ExtendDesignPromptController from "emun.on-demand/media/extend-design-prompt.controller";
import open from "webmodals/open";

let extendDesignPrompt = options => {
  let modalInstance = open({
    size: options.size || "md",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: ExtendDesignPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default extendDesignPrompt;
